import Swiper from 'swiper';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

function instagramSlider() {
    var slider = document.querySelector('[data-element="instagram-slider"]')
    console.log(slider)
    var swiper = new Swiper(slider, {
        modules: [  Navigation],            
        slidesPerView: 1,    
        loop: true,        
        spaceBetween: 30,
        // autoplay: {
        //     delay: 3000,
        //     disableOnInteraction: false,
        //   },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            700: {
                spaceBetween: 40,
                
            },
            828: {
              slidesPerView: 4,
              
              // centeredSlides: false,
            },
        }

    });
    
}

export default instagramSlider;;